import { Fragment } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

export const nl2p = str => (
  <>
    { str.split( /(?:\r\n\r\n|\r\r|\n\n)/g ).map( ( line, i ) => (
      // eslint-disable-next-line react/no-array-index-key
      (<Fragment key={ i }>
        <p
          // eslint-disable-next-line react/no-array-index-key
          key={ i }
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={ { __html: line } }
        />
      </Fragment>)
    ) ) }
  </>
)

/**
 * Note: whereas nl2p returns a JSX object, nl2pIfNotRedactored returns static markup
 * because it’s intended for use with dangerouslySetInnerHTML
 */
export const nl2pIfNotRedactored = str => {
  if ( str.startsWith( '<p>' ) ) {
    return str
  }

  return renderToStaticMarkup( nl2p( str ) )
}

export const nl2br = str => (
  <>
    { str.split( /(?:\r\n|\r|\n)/g ).map( ( line, i ) => (
      // eslint-disable-next-line react/no-array-index-key
      (<Fragment key={ i }>{ line }<br /></Fragment>)
    ) ) }
  </>
)

export const humanList = jsxEls => {
  if ( jsxEls.length < 2 ) {
    return jsxEls
  }

  const separated = jsxEls.reduce( ( r, a, i ) => {
    if ( i === jsxEls.length - 1 ) {
      return r.concat( a )
    }

    if ( i === jsxEls.length - 2 ) {
      return r.concat( a, ' and ' )
    }

    return r.concat( a, ', ' )
  }, [] )

  return separated
}

export const truncate = ( { str, charCount, seperator = '…' } ) => {
  if ( str.length <= charCount ) {
    return str
  }

  const charsToKeep = charCount - seperator.length
  const charCountFront = Math.ceil( charsToKeep / 2 )
  const charCountBack = Math.floor( charsToKeep / 2 )

  return `${ str.substr( 0, charCountFront ) }${ seperator }${ str.substr( str.length - charCountBack ) }`
}
